import { Component } from "@angular/core";

@Component({
    selector:'app-contact',
    templateUrl:'./contactcomponent.html',
    styleUrl:'./contactcomponent.scss',
    standalone: false
})
export class ContactComponent{
    email:string ='RA-PWODPPBC@pa.gov'
}